import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, ownerOnly = false }) {
  const { user, ready } = useAuth();
  const location = useLocation();
  if (!ready) {
    return (
      <div className="staff-scope min-h-screen flex items-center justify-center">
        <div className="text-zinc-500 font-plex text-sm">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/staff-portal" replace state={{ from: location }} />;
  // Owner has all admin abilities; admin does not have owner abilities.
  if (ownerOnly && user.role !== "owner") return <Navigate to="/staff" replace />;
  if (adminOnly && user.role !== "owner" && user.role !== "admin") return <Navigate to="/staff" replace />;
  return children;
}
